import { render, staticRenderFns } from "./ReviseRecordList.vue?vue&type=template&id=82273d7e&scoped=true"
import script from "./ReviseRecordList.vue?vue&type=script&lang=js"
export * from "./ReviseRecordList.vue?vue&type=script&lang=js"
import style0 from "./ReviseRecordList.vue?vue&type=style&index=0&id=82273d7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82273d7e",
  null
  
)

export default component.exports